import { COLORS } from '@bcm/constants';
import { ICON_TYPES } from './iconTypes';

export default {
	burnFlame: {
		name: 'local-fire-department',
		type: ICON_TYPES.materialIcons,
		style: { color: COLORS.burn.flame},
		text: 'Flame',
	},
	burnHeat: {
		name: 'do-not-touch',
		type: ICON_TYPES.materialIcons,
		style: { color: COLORS.burn.heat},
		text: 'Heat',
	},
	burnScald: {
		name: 'mug-hot',
		type: ICON_TYPES.fontAwesome5,
		style: { color: COLORS.burn.scald},
		text: 'Scald',
	},
	burnScaldOil: {
		name: 'oil-temperature',
		type: ICON_TYPES.materialCommunityIcons,
		style: { color: COLORS.burn.scaldOil},
		text: 'Oil Scald',
	},
	burnChemical: {
		name: 'flask-outline',
		type: ICON_TYPES.materialCommunityIcons,
		style: { color: COLORS.burn.chemical},
		text: 'Chemical',
	},
	burnElectrical: {
		name: 'lightning-bolt-outline',
		type: ICON_TYPES.materialCommunityIcons,
		style: { color: COLORS.burn.electrical},
		text: 'Electrical',
	},
};